import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackLinkComponent } from '../../shared/components/back-link/back-link.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { LoadingSpinnerComponent } from '../../shared/components/loading-spinner/loading-spinner.component';
import { RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MarkdownPipe } from '../../markdown.pipe';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-processing-guide',
  templateUrl: './processing.component.html',
  styleUrls: ['./processing.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, MatProgressSpinnerModule, MarkdownPipe, BackLinkComponent, PageHeaderComponent, LoadingSpinnerComponent],
})
export class ProcessingGuideComponent implements OnInit {
  content: string | null = null;
  isLoading = true;
  error: string | null = null;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.http.get(`${environment.apiUrl}/processing-guide`, { responseType: 'text' }).subscribe({
      next: (text) => {
        this.content = text;
        this.isLoading = false;
      },
      error: () => {
        this.error = 'Failed to load processing guide.';
        this.isLoading = false;
      },
    });
  }
}
